import { AgmCoreModule } from '@agm/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { NgxEchartsModule } from 'ngx-echarts';
import { ToastrModule } from 'ngx-toastr';
import { AdlCampaignManagementLibraryInternalComponent } from './adl-campaign-management-library-internal.component';
import { CampaignManagementModule } from './campaign-management/campaign-management.module';
import { CustomPaginator } from './core/util';

@NgModule({
	declarations: [AdlCampaignManagementLibraryInternalComponent],
	imports: [
		CommonModule,
		AgmCoreModule.forRoot({
			apiKey: 'AIzaSyCHReBe_RpzAgLTrUC5QIDyeKttQ817wRY',
			libraries: ['places'],
		}),
		CampaignManagementModule,
		NgxEchartsModule,
		MatCardModule,
		HttpClientModule,
		ToastrModule.forRoot(),
	],
	exports: [AdlCampaignManagementLibraryInternalComponent],
	providers: [{ provide: MatPaginatorIntl, useClass: CustomPaginator }],
})
export class AdlCampaignManagementLibraryInternalModule {}
